var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox"},[_c('div',{staticClass:"mapbox__container",attrs:{"id":"mapContainer"}}),_vm._v(" "),_c('div',{staticClass:"mapbox__side-bar"},[_c('h1',{staticClass:"main-header"},[_vm._v("Discover")]),_vm._v(" "),_c('ul',{attrs:{"id":"map-tabs"}})])])
}]

export { render, staticRenderFns }